export default function (search, param) {
    return new window.URLSearchParams(search).get(param);
}
